import { render, staticRenderFns } from "./view-account-number-overlay.component.vue?vue&type=template&id=641ce550&"
import script from "./view-account-number-overlay.component.vue?vue&type=script&lang=ts&"
export * from "./view-account-number-overlay.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports